var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import T from '../../../../app/Locale';
import axios from 'axios';
import Modal from '@frontend-components/components/Modal';
import Spinner from '@frontend-components/components/Spinner';
import styles from './EIDModal.modules.scss';
const EIDModal = ({ redirect = false, closeModal }) => {
    const [loadingSolution, setLoadingSolution] = useState(null);
    const handleClickNemAdgang = () => {
        if (loadingSolution != null) {
            return;
        }
        setLoadingSolution('nemid');
        window.location.href = `/nemadgang${redirect ? `?redirecturl=${redirect}` : ''}`;
    };
    const handleClickMitId = () => __awaiter(void 0, void 0, void 0, function* () {
        if (loadingSolution != null) {
            return;
        }
        setLoadingSolution('mitid');
        try {
            const { data } = yield axios.get(`/mitid${redirect ? `?redirecturl=${redirect}` : ''}`, { withCredentials: true });
            window.location.href = data;
        }
        catch (error) {
            setLoadingSolution(null);
        }
    });
    return (_jsxs(Modal, Object.assign({ onClose: closeModal, classNames: { modal: styles.modal } }, { children: [_jsx("h2", Object.assign({ "data-behat": "eID-modal-title", className: styles.title }, { children: T.translate('eidModal.title') })), _jsx("p", { className: styles.description, dangerouslySetInnerHTML: { __html: T.translate('eidModal.content') } }), _jsxs("div", Object.assign({ className: styles.buttons }, { children: [_jsx("button", Object.assign({ type: "button", onClick: handleClickMitId, className: styles.button, "data-behat": "modal-mitid-button" }, { children: loadingSolution === 'mitid' ? (_jsx(Spinner, { position: "center" })) : (_jsx("img", { className: styles.buttonIcon, src: "/assets/mitid.svg", alt: "mitid" })) })), _jsx("button", Object.assign({ type: "button", onClick: handleClickNemAdgang, className: styles.button, "data-behat": "modal-nemid-button" }, { children: loadingSolution === 'nemid' ? (_jsx(Spinner, { position: "center" })) : (_jsx("img", { className: styles.buttonIcon, src: "/assets/nemid.svg", alt: "nemid" })) }))] }))] })));
};
EIDModal.propTypes = {
    redirect: PropTypes.string,
    closeModal: PropTypes.func.isRequired
};
export default EIDModal;
